<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import MediaComponent from "@components/common/Media.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { Media } from "@core/schema/Media.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.Gallery> = $props();
</script>

<div class="overflow-hidden full-width">
	<Carousel items={data.images} options={{ loop: true }}>
		{#snippet item(image: Media)}
			<MediaComponent
				lightbox={lightboxId ?? true}
				width={318}
				height={280}
				sourcesets={{}}
				source={image}
				alt={image.title ?? ""}
				class="object-cover size-full"
				lightboxClass="overflow-hidden w-79.5 h-70 md:w-145 md:h-128 bg-fcrbrown odd:bg-fcrdarkbrown"
			/>
		{/snippet}
	</Carousel>
</div>
